
<div class="container-fluid layout layout--pay">

  <div class="layout__main">

    <!-- Cover Start Date Card -->
    @if (coverDateData) {
      <div class="card card--pay">
        <div class="card-body">
          <div class="card-title">
            <h4>{{ coverDateData.header }}</h4>
          </div>
          <div class="card__content">
            <app-question-date-picker
              [controlLabel]="'Select cover start date'"
              [category]="sessionDetails?.category_id"
              [dateFormat]="'d MMMM yyyy'"
              [jqueryPickerDateFormat]="'dd/mm/yy'"
              [minDate]="minDate"
              [showIcon]="true"
              [maxDate]="maxDate"
              [placeHolder]="'Select cover start date'"
              [initialDate]="initialDate"
              [numberMonths]="numberOfMonths"
              [showRelativeLabel]="true"
              (questionAnswer)="dateChange($event)">
            </app-question-date-picker>
          </div>
        </div>
      </div>
    }

    <!-- Debit Date Card -->
    @if (debitDateOptions.length > 0) {
      <div class="card card--pay">
        <div class="card-body">
          <div class="card-title">
            <h4>{{ debitDateHeader }}</h4>
          </div>
          <div class="card__content">
            <div class="input-wrap">
              <select id="debit-date-select" class="ui-selectmenu">
                <option value="">{{ 'Select debit date' }}</option>
                @for (option of debitDateOptions; track option) {
                  <option [value]="option.day"
                    [selected]="selectedDebitDay === option.day">
                    {{ option.label }}
                  </option>
                }
              </select>
            </div>
          </div>
        </div>
      </div>
    }

    <!-- Payment Frequency Card -->
    @if (payFrequencies.length > 0) {
      <div class="card card--pay">
        <div class="card-body">
          <div class="card-title">
            <h4>{{ payFrequencyHeader }}</h4>
          </div>
          <div class="card__content">
            @for (freq of payFrequencies; track freq) {
              <label class="custom-input custom-input--radio custom-input--pill-complex"
                >
                <input type="radio" name="pay-interval" [value]="freq.frequency_id"
                  [checked]="selectedFrequencyId === freq.frequency_id"
                  (change)="selectFrequency(freq)" />
                  <span class="custom-input__indi"></span>
                  <span class="custom-input__label">
                    <span class="custom-input__label-text">
                      <h5><strong>{{ freq.frequency_name }}</strong></h5>
                      <p class="font-14"><strong>{{ freq.prem_period }}</strong> / {{ freq.frequency_short }}</p>
                    </span>
                    @if (freq.discount) {
                      <div class="custom-input__label-tag">
                        <span class="tag-pill tag-pill--highlight">{{ freq.discount }}</span>
                      </div>
                    }
                  </span>
                </label>
              }
            </div>
          </div>
        </div>
      }

      <!-- Payment Method Card -->
      @if (existingPaymentMethods.length > 0 || newPaymentMethods.length > 0) {
        <div class="card card--pay">
          <div class="card-body">
            <div class="card-title">
              <h4>{{ paymentMethodHeader }}</h4>
            </div>
            <div class="card__content">
              <!-- Tab navigation - only show if there are existing payment methods -->
              @if (existingPaymentMethods.length > 0) {
                <nav class="card-pull tab-nav tab-nav--pay">
                  <div class="tab-nav__inner">
                    <ul class="list-unstyled" id="pay-method-nav">
                      <li class="is-active"><a href="#existing-payment-method">Existing</a></li>
                      <li><a href="#new-payment-method">New</a></li>
                    </ul>
                  </div>
                </nav>
              }
              <div class="tab-content" id="pay-method-content">
                <!-- Existing Payment Methods -->
                @if (existingPaymentMethods.length > 0) {
                  <div class="tab-content__item is-active" id="existing-payment-method">
                    <div id="payment-option-accordion-existing">
                      @for (method of existingPaymentMethods; track method; let i = $index) {
                        <div class="selectable">
                          <a [href]="'#payment-option-existing-' + i" data-toggle="collapse" class="selectable__head collapsed"
                            aria-expanded="false" (click)="selectPaymentMethod(method)">
                            <div class="selectable__select">
                              <label class="custom-input custom-input--lg custom-input--radio">
                                <input type="radio" [value]="method.person_bank_id" name="payment-how-existing"
                                  [checked]="selectedPaymentMethod?.person_bank_id === method.person_bank_id" />
                                  <span class="custom-input__indi"></span>
                                  <span class="custom-input__label">
                                    <div>
                                      <strong>{{ method.pay_type_name }}</strong>
                                      <br><small class="text-color-grey-7">{{ method.account_header }}</small>
                                    </div>
                                  </span>
                                </label>
                              </div>
                              <aside class="selectable__aside">
                                @if (method.account_type_logo) {
                                  <div class="selectable__aside-logos">
                                    <img [src]="method.account_type_logo" alt="" />
                                  </div>
                                }
                              </aside>
                            </a>
                            <div class="selectable__content collapse" [id]="'payment-option-existing-' + i"
                              data-parent="#payment-option-accordion-existing">
                              <div class="selectable__content-inner">
                                <!-- Credit card form -->
                                @if (isCreditCard(method)) {
                                  <form class="payment-form">
                                    <div class="row row--sm">
                                      <div class="col-lg">
                                        <div class="form-group">
                                          <label class="form-group__label">Name on card</label>
                                          <input type="text" class="form-control" [value]="method.card_name || method.account_name" placeholder="" />
                                        </div>
                                      </div>
                                      <div class="col-lg">
                                        <div class="form-group">
                                          <label class="form-group__label">Card number</label>
                                          <div class="input-group">
                                            <input type="text" inputmode="numeric" class="form-control" [value]="method.card_no || method.account_number" data-mask="0000 0000 0000 0000" />
                                            <div class="input-group-append">
                                              <span class="input-group-icon"><svg class="icon"><use xlink:href="#card-visa-small"></use></svg></span>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div class="row row--sm">
                                      <div class="col-sm">
                                        <div class="form-group">
                                          <label class="form-group__label">Expiration Date</label>
                                          <input type="text" class="form-control" placeholder="DD / MM" data-mask="00 / 00" />
                                        </div>
                                      </div>
                                      <div class="col-sm">
                                        <div class="form-group">
                                          <label class="form-group__label">CVV Number</label>
                                          <input type="text" class="form-control" placeholder="" data-mask="000" />
                                        </div>
                                      </div>
                                    </div>
                                    <div class="row row--sm">
                                      <div class="col-lg-6">
                                        <div class="form-group form-group--sm">
                                          <label>Payment date</label>
                                          <div class="ui-datepicker__wrap">
                                            <div class="form-control__wrap has-icon">
                                              <input type="text" class="form-control form-control--datepicker" [id]="'day-only-existing-cc-' + i" placeholder="Select day of month" readonly />
                                              <span class="form-control__icon"><svg class="icon"><use xlink:href="#calendar"></use></svg></span>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </form>
                                } @else {
                                  <div class="row row--sm">
                                    <div class="col-lg">
                                      <div class="form-group form-group--sm">
                                        <label>Account holder's name</label>
                                        <input type="text" class="form-control" [value]="method.account_name" placeholder="Account name" />
                                      </div>
                                    </div>
                                    <div class="col-lg">
                                      <div class="form-group form-group--sm">
                                        <label>Name of bank</label>
                                        <input type="text" class="form-control" [value]="method.bank_name?.trim()" placeholder="Bank" />
                                      </div>
                                    </div>
                                  </div>
                                  <div class="row row--sm">
                                    <div class="col-lg">
                                      <div class="form-group form-group--sm">
                                        <label>Account number</label>
                                        <input type="text" class="form-control" [value]="method.account_number" placeholder="Account number" />
                                      </div>
                                    </div>
                                    <div class="col-lg">
                                      <div class="form-group form-group--sm">
                                        <label>Branch code</label>
                                        <input type="text" class="form-control" [value]="method.branch_code" placeholder="Branch code" />
                                      </div>
                                    </div>
                                  </div>
                                  <div class="row row--sm">
                                    <div class="col-lg">
                                      <div class="form-group form-group--sm">
                                        <label>Account type</label>
                                        <select class="ui-selectmenu account-type-existing-select">
                                          <option disabled>Select</option>
                                          <option value="1" [selected]="method.account_type === 'Current Account'">Current Account</option>
                                          <option value="2" [selected]="method.account_type === 'Savings Account'">Savings Account</option>
                                          <option value="3" [selected]="method.account_type === 'Credit Card Account'">Credit Card Account</option>
                                          <option value="4" [selected]="method.account_type === 'Transaction Account'">Transaction Account</option>
                                        </select>
                                      </div>
                                    </div>
                                  </div>
                                }
                                <!-- Debit order form -->
                              </div>
                            </div>
                          </div>
                        }
                        <!-- /.selectable -->
                      </div>
                    </div>
                  }
                  <!-- New Payment Methods -->
                  <div class="tab-content__item" [class.is-active]="existingPaymentMethods.length === 0" id="new-payment-method">
                    <div id="payment-option-accordion-new">
                      @for (method of newPaymentMethods; track method; let i = $index) {
                        <div class="selectable">
                          <a [href]="'#payment-option-new-' + i" data-toggle="collapse" class="selectable__head collapsed"
                            aria-expanded="false" (click)="selectPaymentMethod(method)">
                            <div class="selectable__select">
                              <label class="custom-input custom-input--lg custom-input--radio">
                                <input type="radio" [value]="method.pay_type_id" name="payment-how-new" />
                                <span class="custom-input__indi"></span>
                                <span class="custom-input__label"><strong>{{ method.pay_type_name }}</strong></span>
                              </label>
                            </div>
                            <!-- Type-specific logos -->
                            <aside class="selectable__aside">
                              <div class="selectable__aside-logos">
                                @if (isCreditCard(method)) {
                                  <img src="/assets/img/payment/visa.svg" alt="" />
                                  <img src="/assets/img/payment/mastercard.svg" alt="" />
                                }
                                @if (method.pay_type_name?.toLowerCase().includes('sid')) {
                                  <img src="/assets/img/payment/sd-eft.png" alt="" />
                                }
                                @if (method.pay_type_name?.toLowerCase().includes('payfast')) {
                                  <img src="/assets/img/payment/payfast.svg" alt="" />
                                }
                                @if (method.pay_type_name?.toLowerCase().includes('ozow')) {
                                  <img src="/assets/img/payment/ozow.png" alt="" />
                                  <img src="/assets/img/payment/i-pay.png" alt="" />
                                }
                                @if (method.pay_type_name?.toLowerCase().includes('paypal')) {
                                  <img src="/assets/img/payment/paypal.svg" alt="" />
                                }
                                @if (method.pay_type_name?.toLowerCase().includes('snapscan')) {
                                  <img src="/assets/img/payment/snapscan.svg" alt="" />
                                }
                              </div>
                            </aside>
                          </a>
                          <div class="selectable__content collapse" [id]="'payment-option-new-' + i"
                            data-parent="#payment-option-accordion-new">
                            <div class="selectable__content-inner">
                              <!-- Credit card form -->
                              @if (isCreditCard(method)) {
                                <form class="payment-form">
                                  <div class="row row--sm">
                                    <div class="col-lg">
                                      <div class="form-group">
                                        <label class="form-group__label">Name on card</label>
                                        <input type="text" class="form-control" value="" placeholder="" />
                                      </div>
                                    </div>
                                    <div class="col-lg">
                                      <div class="form-group">
                                        <label class="form-group__label">Card number</label>
                                        <div class="input-group">
                                          <input type="text" inputmode="numeric" class="form-control" value="" data-mask="0000 0000 0000 0000" />
                                          <div class="input-group-append">
                                            <span class="input-group-icon"><svg class="icon"><use xlink:href="#card-visa-small"></use></svg></span>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="row row--sm">
                                    <div class="col-sm">
                                      <div class="form-group">
                                        <label class="form-group__label">Expiration Date</label>
                                        <input type="text" class="form-control" value="" placeholder="DD / MM" data-mask="00 / 00" />
                                      </div>
                                    </div>
                                    <div class="col-sm">
                                      <div class="form-group">
                                        <label class="form-group__label">CVV Number</label>
                                        <input type="text" class="form-control" value="" placeholder="" data-mask="000" />
                                      </div>
                                    </div>
                                  </div>
                                  <div class="row row--sm">
                                    <div class="col-lg-6">
                                      <div class="form-group form-group--sm">
                                        <label>Payment date</label>
                                        <div class="ui-datepicker__wrap">
                                          <div class="form-control__wrap has-icon">
                                            <input type="text" class="form-control form-control--datepicker" [id]="'day-only-new-cc-' + i" value="" placeholder="Select day of month" readonly />
                                            <span class="form-control__icon"><svg class="icon"><use xlink:href="#calendar"></use></svg></span>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </form>
                              }
                              <!-- Debit order form -->
                              @if (isDebitOrder(method)) {
                                <div class="row row--sm">
                                  <div class="col-lg">
                                    <div class="form-group form-group--sm">
                                      <label>Account holder's name</label>
                                      <input type="text" class="form-control" [class.has-error]="method.missing_account_name" [(ngModel)]="method.account_name" (blur)="validateDebitOrder(method)" placeholder="Account name" />
                                      @if (method.missing_account_name) {
                                        <p class="form-control-error">
                                          <svg class="icon"><use xlink:href="#warning-filled"></use></svg>
                                          Account holder's name is required.
                                        </p>
                                      }
                                    </div>
                                  </div>
                                  <div class="col-lg">
                                    <app-question-dropdown
                                      [options]="bankOptions"
                                      [labelText]="'Select Bank'"
                                      [showLabel]="true"
                                      [showOptionLabel]="true"
                                      [selectedValue]="method.bank_id"
                                      [controlCssClass]="method.missing_bank ? 'form-group form-group--sm has-error' : 'form-group form-group--sm'"
                                      (questionAnswer)="selectBank(method, $event)">
                                    </app-question-dropdown>
                                    @if (method.missing_bank) {
                                      <p class="form-control-error">
                                        <svg class="icon"><use xlink:href="#warning-filled"></use></svg>
                                        Please select a bank.
                                      </p>
                                    }
                                  </div>
                                </div>
                                <div class="row row--sm">
                                  <div class="col-lg">
                                    <div class="form-group form-group--sm">
                                      <label>Account number</label>
                                      <input type="text" class="form-control" [class.has-error]="method.missing_account_number || method.account_number_invalid" [(ngModel)]="method.account_number" (blur)="validateDebitOrder(method)" placeholder="Account number" />
                                      @if (method.missing_account_number) {
                                        <p class="form-control-error">
                                          <svg class="icon"><use xlink:href="#warning-filled"></use></svg>
                                          Account number is required.
                                        </p>
                                      }
                                      @if (!method.missing_account_number && method.account_number_invalid) {
                                        <p class="form-control-error">
                                          <svg class="icon"><use xlink:href="#warning-filled"></use></svg>
                                          Account number invalid.
                                        </p>
                                      }
                                    </div>
                                  </div>
                                  <div class="col-lg">
                                    <div class="form-group form-group--sm">
                                      <label>Branch code</label>
                                      <input type="text" class="form-control" [class.has-error]="method.missing_branch_code || method.branch_code_invalid" [(ngModel)]="method.branch_code" (blur)="validateDebitOrder(method)" placeholder="Branch code" />
                                      @if (method.missing_branch_code) {
                                        <p class="form-control-error">
                                          <svg class="icon"><use xlink:href="#warning-filled"></use></svg>
                                          Branch code is required.
                                        </p>
                                      }
                                      @if (!method.missing_branch_code && method.branch_code_invalid) {
                                        <p class="form-control-error">
                                          <svg class="icon"><use xlink:href="#warning-filled"></use></svg>
                                          Branch code invalid.
                                        </p>
                                      }
                                    </div>
                                  </div>
                                </div>
                                <div class="row row--sm">
                                  <div class="col-lg">
                                    <app-question-dropdown
                                      [options]="accountTypes"
                                      [labelText]="'Account type'"
                                      [showLabel]="true"
                                      [showOptionLabel]="true"
                                      [selectedValue]="method.account_type_id"
                                      [controlCssClass]="method.missing_account_type ? 'form-group form-group--sm has-error' : 'form-group form-group--sm'"
                                      (questionAnswer)="selectAccountType(method, $event)">
                                    </app-question-dropdown>
                                    @if (method.missing_account_type) {
                                      <p class="form-control-error">
                                        <svg class="icon"><use xlink:href="#warning-filled"></use></svg>
                                        Please select an account type.
                                      </p>
                                    }
                                  </div>
                                </div>
                              }
                              <!-- EFT / PayPal / SnapScan / Manual EFT — simple placeholder -->
                              @if (!isCreditCard(method) && !isDebitOrder(method)) {
                                <div class="form-group">
                                  <input type="text" class="form-control" value="" placeholder="Placeholder" />
                                </div>
                              }
                            </div>
                          </div>
                        </div>
                      }
                      <!-- /.selectable -->
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        }

        <div class="card card--pay">
          <div class="card-body">
            <div class="card-title">
              <h4>Legal</h4>
            </div>
            <div class="card__content">

              @if (!(user?.broker_id > 0)) {
                <ul class="table-list mb-20">
                  @for (doc of documents; track doc) {
                    <li>
                      <a href="javascript:void(0);" (click)="openDocument(doc)"><small class="font-semibold">{{ doc?.document_name }}</small></a>
                    </li>
                  }
                </ul>
              }

              @if (!(user?.broker_id > 0)) {
                <div class="form-group">
                  <label class="custom-input custom-input--checkbox">
                    <input type="checkbox" name="checkbox-legal" [(ngModel)]="legalAgreed" />
                    <span class="custom-input__indi"></span>
                    <span class="custom-input__label">
                      <strong>
                        I agree that I have read, agreed to and acknowledged the aforementioned
                      </strong>
                    </span>
                  </label>
                </div>
              }

              @if (user?.broker_id > 0) {
                <div class="action-note">
                  <div class="action-note__content">
                    <h5 class="font-16">Get digital confirmation from client</h5>
                    <p>Your client will receive an email with a link to accept the legal stuff themselves.</p>
                  </div>
                  <div class="action-note__actions">
                    <a href="javascript:void(0);" class="button button--primary button--md button--no-min" (click)="sendConsentLink()">Send link</a>
                  </div>
                </div>
                <div class="accordion accordion--cards-alt mt-20 mb-20">
                  <div class="accordion__item">
                    <a href="#legal-consent" class="accordion__title" data-toggle="collapse" aria-expanded="true">
                      <div class="accordion__title-text">
                        <h5 class="font-16">Get verbal consent from client now</h5>
                        <p>After submitting the verbal consent recording, your client will receive the confirmation of policy.</p>
                      </div>
                      <div class="accordion__title-caret">
                        <svg class="icon"><use xlink:href="#dropdown"></use></svg>
                      </div>
                    </a>
                    <div class="accordion__body collapse show" id="legal-consent">
                      <div class="accordion__content">
                        <div class="form-group pt-10">
                          <app-question-upload
                            [question]="verbalConsentQuestion"
                            [acceptedFileTypes]="'video/mp4,video/x-m4v,video/*'"
                            (questionAnswer)="onVerbalConsentUploaded($event)">
                          </app-question-upload>
                        </div>
                        <div class="form-group mb-0">
                          <label class="custom-input custom-input--checkbox">
                            <input type="checkbox" name="checkbox-legal-broker" [(ngModel)]="legalAgreed" />
                            <span class="custom-input__indi"></span>
                            <span class="custom-input__label">
                              <span>I have read the terms to the client and the client agreed to the documents listed above.</span>
                            </span>
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="action-note">
                  <div class="action-note__content">
                    <h5 class="font-16">Send PDFs to the client to print, sign and return</h5>
                    <p>Your client will receive an email with PDF attachments of the legal documents and will be asked to sign and return it to you to upload and complete the quote.</p>
                  </div>
                  <div class="action-note__actions">
                    <a href="#send-pdf-quote-modal" data-toggle="modal" class="button button--primary button--md button--no-min">Send PDFs</a>
                  </div>
                </div>
              }

            </div>
          </div>
        </div>




      </div>
      <div class="layout__sidecol">
        <!-- payment panel - desktop version -->
        <div class="payment-breakdown-panel">

          <div class="payment-breakdown">
            @if (paymentBreakdown?.img_path) {
              <div class="payment-breakdown__company">
                <img [src]="paymentBreakdown?.img_path" [alt]="paymentBreakdown?.product_name" class="img-fluid" />
              </div>
            }
            <div class="payment-breakdown__title">
              <h5>{{ paymentBreakdown?.product_name || selectedProduct?.product_name }}</h5>
            </div>

            @if (paymentBreakdown && !loadingBreakdown) {
              <div>
                <div class="payment-breakdown__items">
                  @if (paymentBreakdown?.due_today) {
                    <div class="payment-breakdown__item">
                      <div class="payment-breakdown__item-label">
                        <p><strong>Due today</strong></p>
                      </div>
                      <div class="payment-breakdown__item-value">
                        <p class="price price--sm"><strong>{{ paymentBreakdown?.due_today }}</strong></p>
                      </div>
                      @if (paymentBreakdown?.due_today_text) {
                        <div class="payment-breakdown__item-note">
                          <p>{{ paymentBreakdown?.due_today_text }}</p>
                        </div>
                      }
                    </div>
                  }
                  <div class="payment-breakdown__item">
                    <div class="payment-breakdown__item-label">
                      <p><strong>Premium</strong></p>
                    </div>
                    <div class="payment-breakdown__item-value">
                      <p class="price"><strong>{{ paymentBreakdown?.premium }}</strong>/{{ paymentBreakdown?.frequency_short }}</p>
                    </div>
                    @if (paymentBreakdown?.premium_due_text) {
                      <div class="payment-breakdown__item-note">
                        <p>{{ paymentBreakdown?.premium_due_text }}</p>
                      </div>
                    }
                  </div>
                </div>
                <div class="payment-breakdown__btn">
                  <a href="javascript:;" class="button button--lg button--block button--primary" [attr.disabled]="payButtonDisabled ? true : null" (click)="gotToNext()">{{ paymentBreakdown?.pay_button_text }}</a>
                </div>
              </div>
            }

            @if (!paymentBreakdown || loadingBreakdown) {
              <div>
                <div class="payment-breakdown__items loading-skeleton-fade">
                  <div class="payment-breakdown__item">
                    <div class="payment-breakdown__item-label">
                      <div class="loading-skeleton-text" style="width:60px"></div>
                    </div>
                    <div class="payment-breakdown__item-value">
                      <div class="loading-skeleton-text" style="width:80px"></div>
                    </div>
                  </div>
                  <div class="payment-breakdown__item">
                    <div class="payment-breakdown__item-label">
                      <div class="loading-skeleton-text" style="width:120px"></div>
                    </div>
                    <div class="payment-breakdown__item-value">
                      <div class="loading-skeleton-text" style="width:60px"></div>
                    </div>
                  </div>
                </div>
                <div class="payment-breakdown__btn">
                  <a href="#" class="button button--lg button--block button--primary" disabled>Pay Now</a>
                </div>
              </div>
            }

          </div>

        </div>
        <!-- /payment panel - desktop version -->
        <!-- /payment panel - mobile version -->
      </div>

      <div class="layout__back">
        <button class="button button--back-alt" id="prev-question-alt" title="Back" (click)="goBack()">
          <svg class="icon">
            <use xlink:href="#arrow-left-small"></use>
          </svg>
        </button>
      </div>


      <!-- payment panel - mobile version -->
      @if (paymentBreakdown && !loadingBreakdown) {
        <div class="payment-breakdown-trigger">
          <div class="payment-breakdown-trigger__control">
            <a href="#modal-payment-breakdown" data-toggle="modal" class="payment-breakdown-trigger__link">
              <svg class="icon">
                <use xlink:href="#chevron-down-smaller"></use>
              </svg>
              <div>
                <small><strong>Breakdown</strong></small>
                <p class="price price--xs"><strong>{{ paymentBreakdown?.premium }}</strong> /{{ paymentBreakdown?.frequency_short }}</p>
              </div>
            </a>
          </div>
          <div class="payment-breakdown-trigger__btn">
            <a href="javascript:;" class="button button--block button--primary" [attr.disabled]="payButtonDisabled ? true : null" (click)="gotToNext()">{{ paymentBreakdown?.pay_button_text }}</a>
          </div>
        </div>
      }

      @if (!paymentBreakdown || loadingBreakdown) {
        <div class="payment-breakdown-trigger">
          <div class="payment-breakdown-trigger__control">
            <a href="#modal-payment-breakdown" data-toggle="modal" class="payment-breakdown-trigger__link">
              <svg class="icon">
                <use xlink:href="#chevron-down-smaller"></use>
              </svg>
              <div>
                <small><strong>Breakdown</strong></small>
                <div class="loading-skeleton-text" style="width:120px"></div>
              </div>
            </a>
          </div>
          <div class="payment-breakdown-trigger__btn">
            <a href="#" class="button button--block button--primary" disabled>Pay Now</a>
          </div>
        </div>
      }


      <!-- tray modal (mobile only) -->
      <div class="modal fade modal--tray" id="modal-payment-breakdown" tabindex="-1" role="dialog" aria-labelledby="modal-payment-breakdown" aria-hidden="true">
        <div class="modal-dialog">
          <div class="modal-content modal-traymenu">

            <div class="modal-traymenu__header modal-traymenu__header--no-bdr">
              <div class="container">
                <h5>Breakdown</h5>
                <a href="#" data-dismiss="modal" class="modal-traymenu__header-close">
                  <svg class="icon"><use xlink:href="#close-medium"></use></svg>
                </a>
              </div>
            </div>

            <div class="modal-traymenu__content pb-0">
              <div class="container">

                <!-- same as desktop, except no payment button here -->
                <div class="payment-breakdown">

                  @if (paymentBreakdown?.img_path) {
                    <div class="payment-breakdown__company">
                      <img [src]="paymentBreakdown?.img_path" [alt]="paymentBreakdown?.product_name" class="img-fluid" />
                    </div>
                  }
                  <div class="payment-breakdown__title">
                    <h5>{{ paymentBreakdown?.product_name || selectedProduct?.product_name }}</h5>
                  </div>
                  @if (paymentBreakdown && !loadingBreakdown) {
                    <div class="payment-breakdown__items">
                      @if (paymentBreakdown?.due_today) {
                        <div class="payment-breakdown__item">
                          <div class="payment-breakdown__item-label">
                            <p><strong>Due today</strong></p>
                          </div>
                          <div class="payment-breakdown__item-value">
                            <p class="price price--sm"><strong>{{ paymentBreakdown?.due_today }}</strong></p>
                          </div>
                          @if (paymentBreakdown?.due_today_text) {
                            <div class="payment-breakdown__item-note">
                              <p>{{ paymentBreakdown?.due_today_text }}</p>
                            </div>
                          }
                        </div>
                      }
                      <div class="payment-breakdown__item">
                        <div class="payment-breakdown__item-label">
                          <p><strong>Premium</strong></p>
                        </div>
                        <div class="payment-breakdown__item-value">
                          <p class="price"><strong>{{ paymentBreakdown?.premium }}</strong>/{{ paymentBreakdown?.frequency_short }}</p>
                        </div>
                        @if (paymentBreakdown?.premium_due_text) {
                          <div class="payment-breakdown__item-note">
                            <p>{{ paymentBreakdown?.premium_due_text }}</p>
                          </div>
                        }
                      </div>
                    </div>
                  }

                </div>


              </div>
            </div>

          </div>
        </div>
      </div>
      <!-- /modal -->

      <!-- send PDFs quote modal (broker only) -->
      @if (user?.broker_id > 0) {
        <div class="modal fade modal--alert" id="send-pdf-quote-modal" tabindex="-1" role="dialog"
          aria-labelledby="send-pdf-quote-modal" aria-hidden="true">
          <div class="modal-dialog" role="document">
            <div class="modal-content modal-alert modal-alert--alt">
              <div class="modal-alert__heading">
                <div class="container">
                  <a href="javascript:void(0);" class="modal-alert__close" data-dismiss="modal">
                    <svg class="icon"><use xlink:href="#close-medium"></use></svg>
                  </a>
                </div>
              </div>
              <div class="modal-alert__content">
                <div class="container">
                  <div class="rte">
                    <h3>Send the quote</h3>
                  </div>
                  <div class="form-group mb-30">
                    <div class="form-control__wrap has-clear">
                      <input type="email" [(ngModel)]="sendPdfEmail" name="send-pdf-email" placeholder="Client Email Address" class="form-control" />
                    </div>
                  </div>
                  <div class="custom-input__modal-scroller text-left">
                    @if (defaultAttachments.length) {
                      <h5 class="font-16 mb-15">Included by default:</h5>
                      <ul class="icon-list-custom">
                        @for (doc of defaultAttachments; track doc) {
                          <li>
                            <svg class="icon"><use xlink:href="#attachment"></use></svg>
                            <p>{{ doc?.document_name }} (PDF)</p>
                          </li>
                        }
                      </ul>
                    }
                    @if (optionalAttachments.length) {
                      <h5 class="font-16 mt-20 mb-15">Select additional attachments:</h5>
                      @for (doc of optionalAttachments; track doc) {
                        <label class="custom-input custom-input--checkbox custom-input--lg">
                          <input type="checkbox" [(ngModel)]="doc.selected" [name]="'checkbox-attachment-' + doc.document_id" />
                          <span class="custom-input__indi"></span>
                          <span class="custom-input__label">{{ doc?.document_name }} (PDF)</span>
                        </label>
                      }
                    }
                  </div>
                </div>
              </div>
              <div class="modal-alert__button">
                <div class="container">
                  <a href="javascript:void(0);" class="button button--lg button--primary" [class.button--loading]="sendingPdfQuote" (click)="sendPdfQuote()">
                    @if (sendingPdfQuote) {
                      <span class="button__spinner"><span class="spinner"></span></span>
                    }
                    Send Quote
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      }
      <!-- /modal -->

    </div>

